import { render, staticRenderFns } from "./CourseManagementList.vue?vue&type=template&id=1b307179"
import script from "./CourseManagementList.vue?vue&type=script&lang=js"
export * from "./CourseManagementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports